import { CoachingVisitState } from '../../../../../../generated/webapp_gql';

export const POST_SESSION_REJOIN_VIDEO_BUFFER_TIME = 10; // minutes

export enum SessionActionsTestID {
  CancelVisitButton = 'SessionActionsTestID.CancelVisitButton',
  CopyVideoSessionLinkButton = 'SessionActionsTestID.CopyVideoSessionLinkButton',
  CopySessionBtnCheckIcon = 'SessionActionsTestID.CopySessionBtnCheckIcon',
  CopySessionBtnCopyIcon = 'SessionActionsTestID.CopySessionBtnCopyIcon',
  JoinVideoSessionButton = 'SessionActionsTestID.JoinVideoSessionButton',
  EditReportVisitButton = 'SessionActionsTestID.EditReportVisitButton',
}

export const DEFAULT_CANCELABLE_SESSION_STATES: string[] = [CoachingVisitState.Scheduled];

export const HPI_CANCELABLE_SESSION_STATES: string[] = [
  CoachingVisitState.PendingPayment,
  CoachingVisitState.PendingConfirmation,
];
